import React, {useState} from "react";
import {t} from "i18next";
import {useDispatch, useSelector} from "react-redux";
import MarkdownModal from "components/MarkdownModal";
import {patchIncident} from "store/features/incidentDetailSlice";
import {
  selectIncidentDescription,
  selectIncidentDetailId
} from "store/selectors";
import {
  sendIncidentsLongDescriptionTelemetry,
  sendIncidentsViewLongDescriptionTelemetry
} from "api/telemetry/incidentsTelemetrics";
import {getShortId} from "utils/misc";

const LongDescription = () => {
  const dispatch = useDispatch();
  const description = useSelector(selectIncidentDescription);
  const incidentId = useSelector(selectIncidentDetailId);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleButtonClick = (e) => {
    const shortId = getShortId(incidentId);

    e.stopPropagation();
    setIsModalOpen(true);
    sendIncidentsViewLongDescriptionTelemetry(shortId);
  };

  return (
    <>
      <a
        role="button"
        data-testid={"ShortDescription-Link-long-description"}
        className="pa-0 text-no-wrap"
        onClick={(e) => handleButtonClick(e)}>
        {t("incidentDetail.detail.longDescriptionBtn")}
      </a>
      {isModalOpen && (
        <MarkdownModal
          defaultValue={description}
          isOpen={isModalOpen}
          setIsOpen={setIsModalOpen}
          setTelemetry={sendIncidentsLongDescriptionTelemetry}
          testId="LongDescription"
          title={t("incidentDetail.detail.description.title")}
          onSubmit={(value) =>
            dispatch(
              patchIncident({
                incidentId,
                patch: {
                  description: value
                }
              })
            )
          }
        />
      )}
    </>
  );
};

export default LongDescription;
